import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { FormlyFieldInput } from './input.type';
import { FormlyFormFieldModule } from '../form-field/public_api';

@NgModule({
    declarations: [FormlyFieldInput],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormlyFormFieldModule,
        InputsModule,
        FormlyModule.forChild({
            types: [
                {
                    name: 'kendo-input',
                    component: FormlyFieldInput,
                    wrappers: ['kendo-form-field'],
                },
                { name: 'kendo-string', extends: 'kendo-input' },
                {
                    name: 'kendo-number',
                    extends: 'kendo-input',
                    defaultOptions: {
                        props: {
                            type: 'number',
                        },
                    },
                },
                {
                    name: 'kendo-integer',
                    extends: 'kendo-input',
                    defaultOptions: {
                        props: {
                            type: 'number',
                        },
                    },
                },
            ],
        }),
    ],
})
export class FormlyInputModule { }
